import { Dispatch, SetStateAction } from "react";

import { TableColumn } from "@/components/Table/Table";

import { SortParams } from "@/types/types";

import { AssignStatus } from "@/enum/list.enum";

import {
	renderAboutColumn,
	renderAssignToColumn,
	renderCompanyCityColumn,
	renderCompanyColumn,
	renderCompanyCountryColumn,
	renderCompanyPeopleCheckColumn,
	renderCompanyStateColumn,
	renderConnectionsColumn,
	renderEstimatedNumEmployeesColumn,
	renderFollowers,
	renderFoundedYearColumn,
	renderGenderColumn,
	renderHeadlineColumn,
	renderIndustryColumn,
	renderLanguageColumn,
	renderLiCompanyActivityConnectedAtColumn,
	renderNameColumn,
	renderPersonCityColumn,
	renderPersonCountryColumn,
	renderPersonStateColumn,
	renderSelectColumn,
	renderSeniorityColumn,
	renderSourceNameColumn,
	renderTitleColumn,
	renderCreatedAt,
	renderSalutationDeColumn,
	renderSalutationEnColumn,
	renderExclusionReasonColumn,
	renderPreviousEmployersColumn,
	renderCompanyScoreColumn,
	renderPersonaCategoryColumn,
	renderCompanyCategoryColumn,
	renderPersonaScoreColumn,
	renderReportetEmployeesColumn,
	renderRoleChangeColumn,
	renderPreviousJobTitleColumn,
	renderPreviousEmployerColumn,
	renderCampaignAddedAt,
	renderAssignedStatusColumn,
	renderLastNodeTypeColumn,
	renderLastScheduledAtColumn,
	renderLastMessageColumn,
	renderDeepResearchStatusColumn,
} from "../../utils/allColumns";
import {
	renderCompanyOtherListsColumn,
	renderOtherListsColumn,
} from "../../utils/otherListsColumns";
import { renderMaybeColumn } from "../../utils/renderMaybeColumn";
import { GetIrlColumns } from "../CustomerImplementations/IrlColumns";

export interface LiCompanyActivityTableColumnsProps {
	selectAll: boolean;
	setShowAll: Dispatch<SetStateAction<boolean>>;
	toggleSelectAll: () => void;
	selectedItems: number[];
	handleSelectItem: (id: number) => void;
	handleCopyClick: (value: string) => void;
	ts: (key: string) => string;
	sortingInbox: SortParams;
	setShowEdit: ({ id, name }: { id: number; name: string }) => void;
	showEdit: { id: number; name: string } | undefined;
	integrations: { [key: string]: boolean | undefined };
	handleSelectCampaignAndProspect: (
		id: number | string,
		listPersonId: number,
		type?: "internal" | "lemlist"
	) => void;
	assignStatus: AssignStatus;
	onResearchClick?: (row: import("../../schema/list").ListPerson) => void;
	onOpenDetail?: (row: import("../../schema/list").ListPerson) => void;
}

export const LiCompanyActivityTableColumns = ({
	selectAll,
	setShowAll,
	toggleSelectAll,
	selectedItems,
	handleSelectItem,
	handleCopyClick,
	ts,
	sortingInbox,
	setShowEdit,
	showEdit,
	integrations,
	handleSelectCampaignAndProspect,
	assignStatus,
	onResearchClick,
	onOpenDetail,
}: LiCompanyActivityTableColumnsProps): TableColumn[] => {
	const columns = [
		renderSelectColumn(setShowAll, toggleSelectAll, selectAll, selectedItems, handleSelectItem),
		renderMaybeColumn(ts),
		renderAssignToColumn(ts, handleCopyClick, handleSelectCampaignAndProspect),
		renderNameColumn(ts, handleCopyClick, sortingInbox, onOpenDetail),
		renderCompanyColumn(ts, handleCopyClick, sortingInbox, setShowEdit, showEdit),
		renderExclusionReasonColumn(ts, sortingInbox),
		renderDeepResearchStatusColumn(onResearchClick),
		renderCompanyPeopleCheckColumn(ts),
		renderLiCompanyActivityConnectedAtColumn(ts, sortingInbox),
		renderGenderColumn(ts, handleCopyClick, sortingInbox, setShowEdit, showEdit),
		renderSalutationDeColumn(ts),
		renderSalutationEnColumn(ts),
		renderTitleColumn(ts, handleCopyClick, sortingInbox),
		renderHeadlineColumn(ts, handleCopyClick, sortingInbox),
		renderAboutColumn(ts, handleCopyClick, sortingInbox),
		renderSeniorityColumn(ts, handleCopyClick, sortingInbox),
		renderConnectionsColumn(ts, sortingInbox),
		renderIndustryColumn(ts, handleCopyClick, sortingInbox),
		renderEstimatedNumEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderReportetEmployeesColumn(ts, handleCopyClick, sortingInbox),
		renderFoundedYearColumn(ts, handleCopyClick, sortingInbox),
		renderPersonCityColumn(ts, handleCopyClick, sortingInbox),
		renderPersonStateColumn(ts, handleCopyClick, sortingInbox),
		renderPersonCountryColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyCityColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyStateColumn(ts, handleCopyClick, sortingInbox),
		renderCompanyCountryColumn(ts, handleCopyClick, sortingInbox),
		renderLanguageColumn(ts, sortingInbox),
		renderFollowers(ts, sortingInbox),
		renderPreviousEmployersColumn(ts),
		renderPreviousEmployerColumn(ts),
		renderPreviousJobTitleColumn(ts),
		renderOtherListsColumn(ts, sortingInbox),
		renderCompanyOtherListsColumn(ts, sortingInbox),
		renderSourceNameColumn(ts, handleCopyClick, sortingInbox),
		renderCreatedAt(ts, sortingInbox),
	];

	if (assignStatus === AssignStatus.ASSIGNED) {
		columns.push(renderCampaignAddedAt(ts, sortingInbox));
		columns.push(renderAssignedStatusColumn(ts, sortingInbox));
		columns.push(renderLastNodeTypeColumn(ts, sortingInbox));
		columns.push(renderLastScheduledAtColumn(ts, sortingInbox));
		columns.push(renderLastMessageColumn(ts));
	}

	if (integrations.IRL_COUNTRIES_SUM) {
		const irlColumns = GetIrlColumns(ts);

		columns.push(...irlColumns);
	}

	if (integrations.LEAD_SCORING) {
		columns.push(renderPersonaCategoryColumn(sortingInbox));
		columns.push(renderCompanyCategoryColumn(sortingInbox));
		columns.push(renderPersonaScoreColumn(sortingInbox));
		columns.push(renderCompanyScoreColumn(sortingInbox));
	}

	columns.push(renderRoleChangeColumn());

	return columns;
};
